import axios from 'axios';

const list = (data) => axios.get('/custom/rate/list', data);
const save = (data) => axios.post('/custom/rate/save', data);
const del = (data) => axios.post('/custom/rate/delete', data);


export default {
  list,
  save,
  del,

}


